import { fromJS } from 'immutable'
import {
  USER_EDIT_MOVEMENT_REQUEST,
  USER_EDIT_MOVEMENT_SUCCESS,
  USER_EDIT_MOVEMENT_FAILURE,
  USER_EDIT_MOVEMENT_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_EDIT_MOVEMENT_REQUEST:
      return state
        .set('isFetching', true)
    case USER_EDIT_MOVEMENT_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Updated Successfully')
        .set('message', 'The data had successfully been updated')
        .set('employeeEditMovement', fromJS(action.payload))
    case USER_EDIT_MOVEMENT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('employeeEditMovement', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case USER_EDIT_MOVEMENT_RESET:
      return state
        .delete('employeeCreate')
        .delete('type')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-edit-movement-reducer.js